import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marcacao-consulta',
  templateUrl: './marcacao-consulta.component.html',
  styleUrls: ['./marcacao-consulta.component.css']
})
export class MarcacaoConsultaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
}
